<template>
  <van-tabs color="#a96b04" title-active-color="#a96b04">
    <van-tab :title="data.title" v-for="data in datas" :key="data.id">
        <van-image
                :src="data.url"
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
              </van-image>
    </van-tab>
  </van-tabs>
</template>

<script>
export default {
  data() {
    return {
      datas: this.tagArr,
      num: this.size
    };
  },
  props: {
    tagArr: {
      type: Array,
      default: []
    },
    size: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-tab span {
  display: block;
  font-size: 12px;
  font-weight: 600;
}
</style>
